export function isAgentIqEmailAddress(email) {
  const AGENTIQ_EMAIL_SUFFIX = '@agentiq.com';
  if (!email) {
    return false;
  }

  return email.toLowerCase().endsWith(AGENTIQ_EMAIL_SUFFIX);
}